<mat-card>
    <mat-card-header>
        <mat-card-title>
            <prl-label value='label.profiles.all.profiles'/>
            <mx-info-tooltip [config]="profilesTooltip"></mx-info-tooltip>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mx-grid (customize)="onCustomize($event)"></mx-grid>
    </mat-card-content>
</mat-card>